import React, { useEffect, useState } from 'react';
import ApiService from '../../services/ApiService';
import AdminLayout from './AdminLayout';
import './AdminPage.css';

const ReviewsAdminPage = () => {
    const [loading, setLoading] = useState(true);
    const [reviews, setReviews] = useState([]);
    const [page, setPage] = useState(0);
    const [error, setError] = useState('');
    const [busyUserId, setBusyUserId] = useState(null);

    const fetchData = async () => {
        setLoading(true);
        setError('');
        try {
            const response = await ApiService.getAdminReviews(page);
            if (response.type !== 'success') throw new Error(response.message || 'Ошибка загрузки');
            setReviews(Array.isArray(response.data) ? response.data : []);
        } catch (requestError) {
            console.error('Error fetching reviews:', requestError);
            setReviews([]);
            setError('Не удалось загрузить отзывы.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        document.title = 'Отзывы — админ-панель';
        fetchData();
    }, [page]);

    const handleBanToggle = async (user) => {
        const action = user.banned ? 'разблокировать' : 'заблокировать';
        if (!window.confirm(`${action[0].toUpperCase()}${action.slice(1)} пользователя ${user.nickname}?`)) return;
        setBusyUserId(user.id);
        try {
            const response = await ApiService.banUser(user.id, !user.banned);
            if (response.type !== 'success') throw new Error(response.message || 'Ошибка операции');
            await fetchData();
        } catch (requestError) {
            console.error('Error changing user status:', requestError);
            setError('Не удалось изменить статус пользователя.');
        } finally {
            setBusyUserId(null);
        }
    };

    const changePage = (nextPage) => setPage(Math.max(0, Number(nextPage) || 0));

    return (
        <AdminLayout
            mainClassName="admin-list-shell"
            eyebrow="Модерация"
            title="Отзывы"
            lead="Сообщения зрителей и быстрый переход к профилю или тайтлу."
            actions={<button type="button" className="ui-btn ui-btn--secondary ui-btn--sm admin-button" onClick={fetchData} disabled={loading}>Обновить</button>}
        >
            <div className="admin-pagination">
                <span>Страница {page + 1}</span>
                <div className="admin-pagination-controls">
                    <button type="button" className="ui-btn ui-btn--secondary ui-btn--sm admin-button" onClick={() => changePage(page - 1)} disabled={page === 0}>Назад</button>
                    <button type="button" className="ui-btn ui-btn--secondary ui-btn--sm admin-button" onClick={() => changePage(page + 1)}>Дальше</button>
                    <input type="number" min="1" aria-label="Номер страницы" value={page + 1} onChange={(event) => changePage(Number(event.target.value || 1) - 1)} />
                </div>
            </div>

            {loading ? <div className="admin-state">Загрузка отзывов…</div> : null}
            {error ? <div className="admin-notice error" role="alert">{error}</div> : null}
            {!loading && !error && reviews.length === 0 ? <div className="admin-state">На этой странице нет отзывов.</div> : null}

            <div className="admin-record-list">
                {reviews.map((review, index) => {
                    const user = review.user || {};
                    return (
                        <article key={review.id || `${review.animeId}-${user.id}-${index}`} className={`admin-review-row${user.banned ? ' banned' : ''}`}>
                            <p className="admin-review-message">{review.message || 'Пустой отзыв'}</p>
                            <div>
                                <div className="admin-user-identity">
                                    <strong>{user.nickname || 'Неизвестный пользователь'}</strong>
                                    <span>{user.banned ? 'Заблокирован' : 'Активен'}</span>
                                </div>
                                <div className="admin-review-links">
                                    <a href={`/profile/${encodeURIComponent(user.nickname || '')}`}>Профиль</a>
                                    <a href={`/anime/${review.animeId}`}>Тайтл</a>
                                </div>
                            </div>
                            <div className="admin-row-actions">
                                <button
                                    type="button"
                                    className={user.banned ? 'ui-btn ui-btn--secondary ui-btn--sm admin-button' : 'ui-btn ui-btn--sm admin-danger-button'}
                                    onClick={() => handleBanToggle(user)}
                                    disabled={!user.id || busyUserId === user.id}
                                >
                                    {busyUserId === user.id ? 'Обновление…' : user.banned ? 'Разблокировать' : 'Заблокировать'}
                                </button>
                            </div>
                        </article>
                    );
                })}
            </div>
        </AdminLayout>
    );
};

export default ReviewsAdminPage;
